var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "photo-lower-bar-button-group" }, [
    _c(
      "div",
      {
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.deleteSelectedPlane()
          }
        }
      },
      [
        _c("SVGPhotoDelete", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Удалить")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.routeName === "planeCategoriesActiveSelection",
            expression: "routeName === 'planeCategoriesActiveSelection'"
          }
        ],
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.editSelectedPlane()
          }
        }
      },
      [
        _c("SVGAdminEditRow", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Редактировать плоскость")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.cutoutPlanes,
            expression: "!cutoutPlanes"
          }
        ],
        staticClass: "photo-lower-bar-button"
      },
      [
        _c("div", { staticClass: "pretty p-default lb-checkbox" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.useInCalculations,
                expression: "useInCalculations"
              }
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.useInCalculations)
                ? _vm._i(_vm.useInCalculations, null) > -1
                : _vm.useInCalculations
            },
            on: {
              change: function($event) {
                var $$a = _vm.useInCalculations,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.useInCalculations = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.useInCalculations = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.useInCalculations = $$c
                }
              }
            }
          }),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Учитывать при расчётах")]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "state p-danger" }, [_c("label")])
  }
]
render._withStripped = true

export { render, staticRenderFns }